export default __webpack_public_path__ + "static/media/breaking.bda3de89.png";